import DashboardOIGSAMTable from "./DashboardOIGSAMTable";

export default DashboardOIGSAMTable;
